module.exports = __webpack_public_path__ + "static/media/MusicDetailsScreen_elStartplayingCopy2_239064.0d85b8c3.jpg";